import { createTranslations } from '@npco/common-utils-translations'

export const setupFlowCardsStageTranslations = createTranslations({
  badge: 'Cards',
  title: 'Streamline business spending with Zeller Cards.',
  description:
    'Create Debit or Corporate Cards to manage business purchases and simplify payment of expenses, bills, invoices and subscriptions.',
  point1: 'Attach notes, receipts and invoices to transactions.',
  point2: 'Assign contacts to transactions to understand spending.',
  point3: 'Issue virtual cards instantly, or physical cards for fast delivery.',
  point4: 'Use Zeller Corporate Cards to better manage team expenses.',
})
